import { useTranslation } from 'react-i18next';

const PHASE_COLORS = ['#78B928', '#527F19', '#78B928', '#66707A', '#3A4249', '#171A1D'];

export function MiniGantt({ results, label, color = '#78B928' }) {
  const { t } = useTranslation();
  const phases = results?.phases || [];
  let cum = 0;
  const displayPhases = phases.map((phase, idx) => {
    const startWeek = cum;
    cum += phase.durationWeeks;
    return { ...phase, startWeek, color: PHASE_COLORS[idx % PHASE_COLORS.length] };
  });
  // Use engine's authoritative total (avoids rounding drift from summing phases)
  const total = Math.max(1, results?.totalDurationWeeks || displayPhases.reduce((sum, p) => sum + p.durationWeeks, 0));
  const months = Math.ceil(total / 4);

  return (
    <div data-testid={`mini-gantt-${label?.toLowerCase().replace(/\s+/g, '-')}`}>
      {/* Header */}
      <div className="flex items-center gap-2 mb-2">
        <div className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: color }} />
        <span className="text-xs font-bold truncate" style={{ color }}>{label}</span>
        <span
          className="text-xs text-[#8A929B] ml-auto shrink-0"
          style={{ fontFamily: 'IBM Plex Mono, monospace' }}
        >
          {total} {t('estimates.weeks')}
        </span>
      </div>

      {/* Month header */}
      <div className="flex mb-1 pl-28">
        {Array.from({ length: months }, (_, i) => (
          <div
            key={i}
            className="flex-1 text-[9px] text-[#8A929B] pl-1 border-l border-[#DDE1E5]"
            style={{ minWidth: 0 }}
          >
            M{i + 1}
          </div>
        ))}
      </div>

      {/* Phase rows */}
      <div className="space-y-1">
        {displayPhases.map(phase => {
          const startPct = (phase.startWeek / total) * 100;
          const widthPct = Math.max((phase.durationWeeks / total) * 100, 2);
          return (
            <div key={phase.id} className="flex items-center">
              <div className="w-28 shrink-0 pr-3">
                <div className="text-[9px] font-medium text-[#171A1D] truncate"
                     title={t(`calcData.phases.${phase.id}`)}>
                  {t(`calcData.phases.${phase.id}`)}
                </div>
                <div
                  className="text-[9px] text-[#8A929B]"
                  style={{ fontFamily: 'IBM Plex Mono, monospace' }}
                >
                  {phase.durationWeeks}w
                </div>
              </div>
              <div className="flex-1 relative h-5 bg-[#F5F6F7] rounded overflow-hidden">
                <div
                  className="absolute top-0.5 bottom-0.5 rounded-sm"
                  style={{ left: `${startPct}%`, width: `${widthPct}%`, backgroundColor: phase.color }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
